import { useAppSelector } from '../../hooks';
import {
  Navigate,
  Outlet,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import { Sidebar } from '../PageWrapper/Sidebar';
import { Header } from '../PageWrapper/Header';
import { ROUTES } from '../../utils/constants';
import { useEffect } from 'react';

export const redirectKey = 'redirect';

export const AuthLayout = () => {
  const user = useAppSelector((state) => state.user);

  const navigate = useNavigate();
  const location = useLocation();
  const actualPath = location.pathname + location.search;

  const [searchParams] = useSearchParams();
  const redirectAfterLoginPath = searchParams.get(redirectKey);

  useEffect(() => {
    if (!user || !redirectAfterLoginPath) return;
    navigate(redirectAfterLoginPath);
  }, [navigate, redirectAfterLoginPath, user]);

  if (!user) {
    const searchParams = new URLSearchParams();
    searchParams.set(redirectKey, actualPath);

    return (
      <Navigate
        replace
        to={{
          pathname: ROUTES.auth.login,
          search: searchParams.toString(),
        }}
      />
    );
  }

  return (
    <div className="flex">
      <Sidebar />
      <div className="flex flex-col flex-grow">
        <Header />
        <Outlet />
      </div>
    </div>
  );
};
